import DateRangeStartedIcon from '../../../assets/icons_new/DateRangeStarted.svg'
import DateRangeEndedIcon from '../../../assets/icons_new/DateRangeEnded.svg'
import DateRangeCalculatedIcon from '../../../assets/icons_new/DateRangeCalculated.svg'
import DateRangeSettlementMonthIcon from '../../../assets/icons_new/DateRangeSettlementMonth.svg'
import DateRangeModifiedIcon from '../../../assets/icons_new/DateRangeModified.svg'

export enum DateRangeFilter {
  Started = 0,
  Ended = 1,
  Calculated = 2,
  SettlementMonth = 3,
  All = 4,
  AllButSettlementMonth = 5,
  Modified = 6,
}

export const TRIPS_FILTER_OPTIONS = [
  {
    value: DateRangeFilter.Started,
    labelKey: 'Started',
    icon: DateRangeStartedIcon,
  },
  {
    value: DateRangeFilter.Ended,
    labelKey: 'Ended',
    icon: DateRangeEndedIcon,
  },
  {
    value: DateRangeFilter.Calculated,
    labelKey: 'Calculated',
    icon: DateRangeCalculatedIcon,
  },
  {
    value: DateRangeFilter.SettlementMonth,
    labelKey: 'SettlementMonth',
    icon: DateRangeSettlementMonthIcon,
  },
  {
    value: DateRangeFilter.Modified,
    labelKey: 'Modified',
    icon: DateRangeModifiedIcon,
  },
]
